export default __webpack_public_path__ + "static/media/ic_nav_action_back.7b5c1176.svg";